// extracted by mini-css-extract-plugin
export var cardHeader = "_kx-1";
export var contentCard = "_kx-0";
export var headerActions = "_kx-3";
export var reorderHandle = "_kx-5";
export var titleArea = "_kx-2";
export var titleAreaWithHandle = "_kx-4";